/**
 * Função para normalizar texto (remove acentos e converte para minúsculas)
 * @param {string} text - Texto a ser normalizado
 * @returns {string} Texto normalizado sem acentos e em minúsculas
 */
export const normalizeText = (text) => {
  if (!text || typeof text !== 'string') return '';
  
  return text
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();
};

/**
 * Função para aplicar filtros de texto localmente
 * @param {Array} items - Array de itens a serem filtrados
 * @param {Object} filters - Objeto com filtros a serem aplicados
 * @param {Array} searchFields - Array de campos para busca (ex: ['name', 'responsible.name'])
 * @param {Function} setSearchResult - Função para atualizar o resultado da busca
 */
export const applyTextFilters = (items, filters, searchFields, setSearchResult) => {
  let filteredItems = [...items];
  
  // Filtro por texto
  if (filters.text && filters.text.trim()) {
    const searchText = normalizeText(filters.text);
    
    filteredItems = filteredItems.filter(item => {
      return searchFields.some(field => {
        const value = getNestedValue(item, field);
        return normalizeText(value).includes(searchText);
      });
    });
  }
  
  setSearchResult(filteredItems);
};

/**
 * Função para obter valor de propriedade aninhada (ex: 'responsible.name')
 * @param {Object} obj - Objeto a ser consultado
 * @param {string} path - Caminho da propriedade (ex: 'responsible.name')
 * @returns {*} Valor da propriedade ou string vazia se não existir
 */
const getNestedValue = (obj, path) => {
  return path.split('.').reduce((current, key) => {
    return current && current[key] !== undefined ? current[key] : '';
  }, obj) || '';
};

/**
 * Função para verificar se há filtros ativos
 * @param {Object} searchValues - Valores dos filtros
 * @param {string} pageName - Nome da página (ex: 'admin', 'org', 'branch')
 * @returns {boolean} True se há filtros ativos, false caso contrário
 */
export const hasActiveFilters = (searchValues, pageName) => {
  if (!searchValues || !searchValues[pageName]) return false;
  
  return Object.keys(searchValues[pageName]).some(key => {
    const value = searchValues[pageName][key];
    return value && value.toString().trim() !== '';
  });
};
